import type { ReactNode } from 'react';

type Tone = 'info' | 'success' | 'warning' | 'danger';

const ICON_PATHS: Record<Tone, string> = {
  info: 'M10 9v5M10 6h.01',
  success: 'M5.5 10.5l3 3 6-7',
  warning: 'M10 7v4M10 14h.01',
  danger: 'M7 7l6 6M13 7l-6 6',
};

export function Alert({
  tone = 'info',
  title,
  children,
}: {
  tone?: Tone;
  title?: string;
  children?: ReactNode;
}) {
  return (
    <div className={`vs-alert vs-alert--${tone}`} role="status">
      <span className="vs-alert__icon">
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="10" cy="10" r="8" opacity="0.35" />
          <path d={ICON_PATHS[tone]} />
        </svg>
      </span>
      <div>
        {title && <p className="vs-alert__title">{title}</p>}
        {children && <p className="vs-alert__body">{children}</p>}
      </div>
    </div>
  );
}
